import axios from 'axios';
import { baseURL } from '../Constants';

const url = `${baseURL}/LeagueStats`;

// Interfaces
export interface HardstuckPlayer {
    rank: number;
    steamId: string;
    playerName: string;
    currentTeam: string;
    divisionName: string;
    divisionLevel: number;
    seasonsInDivision: number;
    firstSeason: number;
    lastSeason: number;
    totalGamesPlayed: number;
    seasons: number[];
    explanation: string;
}

export interface DivisionClimber {
    steamId: string;
    playerName: string;
    fromDivision: string;
    toDivision: string;
    fromDivisionName: string;
    toDivisionName: string;
    divisionsJumped: number;
    currentTeam: string;
    jumpDescription?: string;
    fallDescription?: string;
}

export interface HardstuckResponse {
    title: string;
    subtitle: string;
    currentSeason: number;
    minSeasons: number;
    players: HardstuckPlayer[];
    generatedAt: string;
    cachedAt?: string;
    cacheExpiresAt?: string;
}

export interface ClimbersResponse {
    fromSeason: number;
    toSeason: number;
    description: string;
    climbers: DivisionClimber[];
    fallers: DivisionClimber[];
}

// Fetch hardstuck players
export const fetchHardstuckPlayers = async (
    currentSeason: number,
    minSeasons: number = 3,
    division: string = 'all'
): Promise<HardstuckResponse> => {
    try {
        const response = await axios.get(`${url}/hardstuck/${currentSeason}/${minSeasons}`, {
            params: { division }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching hardstuck players:', error);
        throw error;
    }
};

// Fetch division climbers
export const fetchDivisionClimbers = async (
    fromSeason: number,
    toSeason?: number
): Promise<ClimbersResponse> => {
    try {
        const endpoint = toSeason 
            ? `${url}/climbers/${fromSeason}/${toSeason}`
            : `${url}/climbers/${fromSeason}`;
        const response = await axios.get(endpoint);
        return response.data;
    } catch (error) {
        console.error('Error fetching division climbers:', error);
        throw error;
    }
};
export interface TalentPlayer {
    steamID: string;
    playerName: string;
    age: number;
    teamName: string;
    division: string;
    divisionLevel: number;
    divisionName: string;
    rating: number;
    kd: number;
    adr: number;
    maps: number;
}

export interface TalentsResponse {
    season: number;
    maxAge: number;
    minMaps: number;
    ratingLabel: string;
    players: TalentPlayer[];
}

// Fetch young players with a known age, sorted by division then rating
export const fetchTalents = async (
    season: number,
    maxAge: number = 19,
    minMaps: number = 3
): Promise<TalentsResponse> => {
    const response = await axios.get(`${url}/talents/${season}`, {
        params: { maxAge, minMaps }
    });
    return response.data;
};
